import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_ALBUMS = "albums";
const BASE_URL = "/api/albums";

const AlbumQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const ALBUM_EMPTY = {title: "", description: "", position: 1,dateCreated:"",reverseSorting:false, albumFrontFile: null, filealbums: []};

export function useAlbums() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ALBUMS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...AlbumQueryConfig
    });
    return {...result, albums: result.data};
}


export function useAlbum(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_ALBUMS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...AlbumQueryConfig
    });
    return {...result, album: result.data};
}

export function useAlbumsMutations() {
    async function createFunction(album) {
        if (!album) return;
        return await fetchPOST(BASE_URL, album, false);
    }

    async function editFunction(album) {
        if (!album) return;
        return await fetchPUT(`${BASE_URL}/${album.id}`, album);
    }

    async function editAddNewFiles(album) {
        if (!album) return;
        return await fetchPUT(`${BASE_URL}/${album.id}/files`, album.filesIds);
    }

    async function deleteFunction(album) {
        return await fetchDELETE(`${BASE_URL}/${album.id}`)
    }

    return {
        createAlbum: useMyMutation(createFunction, REACT_QUERY_ID_ALBUMS, album => `Album ${album.title} created`),
        editAlbum: useMyMutation(editFunction, REACT_QUERY_ID_ALBUMS, album => `Album ${album.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_ALBUMS, album => `Album ${album.title} modified`),
        deleteAlbum: useMyMutation(deleteFunction, REACT_QUERY_ID_ALBUMS, album => `Album ${album.title} deleted.`)
    };

}